export const seckillAdapter = module => {
  Object.assign(module.style, {
    countDownText: module.style.other.chutDownText,
    promoteCountDownText: module.style.other.promoteSeckillText,
    titleImg: module.style.attachImg1,
    cornerFontColor: module.style.cornerFontColor,
    cornerBgColor: module.style.cornerBgColor,
    // type: module.style.type
    type: 'promotion',
    bgImg: module.style.bgImg
  })
  module.data[0].serverTime = module.style.other.timeStamp
  module.data[0].startTime = module.data[0].meta_info.start_time
  module.data[0].endTime = module.data[0].meta_info.end_time
  module.moduleName = 'seckill'
  module.layoutType = 'promotion'
  return module
}
